import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "color", "hasBgImage"];
import "core-js/modules/es.function.name.js";
import React, { forwardRef } from 'react';
import ThemeSection from 'components/ThemeSection';
import IconDisc from 'components/IconDisc';

/*
 * This is a wrapper around the IconDisc component that
 * provides asset-specific theme colors to it.
 */

var AssetIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
    color = _ref.color,
    hasBgImage = _ref.hasBgImage,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (otherProps.shady) {
    // If the `shady` prop is set, the icon will be
    // displayed on a semi-transparent background, so
    // it shouldn't use asset colours and instead adapt
    // to its surrounding theme section
    return /*#__PURE__*/React.createElement(IconDisc, _extends({}, otherProps, {
      ref: ref,
      name: name
    }));
  }
  return /*#__PURE__*/React.createElement(ThemeSection, {
    name: color || name,
    withBackgroundImage: hasBgImage
  }, /*#__PURE__*/React.createElement(IconDisc, _extends({}, otherProps, {
    ref: ref,
    name: name
  })));
});
AssetIcon.displayName = 'AssetIcon';
export default AssetIcon;